import { BlankSheetDefinition } from "../../blankSheet.definition";
import { BottomSheetDefinition } from "./bottomSheet.definition.types";

export const bottomSheetDefinition: BottomSheetDefinition =
  BlankSheetDefinition;
